module.exports = __webpack_public_path__ + "img/15.f991d3e0.png";